import { TimelineItem, TimelineItemSettings } from 'app/views/home/timeline/TimelineItem';
import { TimelineItemConfig } from 'app/model/TimelineItemConfig';

//Masked text item timeline item used for Debug logo
export class MaskedText extends TimelineItem {
	private _background: PIXI.Sprite;
	private _mask: PIXI.Sprite;

	public create(jsonConfig: TimelineItemConfig, settings: TimelineItemSettings): void {
		super.create(jsonConfig, settings);
		this._background = new PIXI.Sprite(settings.backgroundTexture);
		this._mask = new PIXI.Sprite(settings.maskTexture);

		this._mask.anchor.set(0.5, 0.5);
		this._background.anchor.set(0.5, 0.5);
		this._sprite.anchor.set(0.5, 0.5);
		this._sprite.addChild(this._background, this._mask);
		this._background.mask = this._mask;
	}
}
